<section class="container">
  <div class="table-responsive" *ngIf="ecgTerceirosPesquisado || ecgTerceirosPesquisado.length">
    <table class="table table-hover cursor-pointer">
      <thead>
      <tr class="text-nowrap">
        <th id="col-nomeTipoPagamentoEcgTerceiro" scope="col">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'nomeTipoPagamentoEcgTerceiro'"
            [nomeAtributoExibicao]="'ECG pago por '"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of ecgTerceirosPesquisado" id="pointer">
        <td  [routerLink]="['/ecg-por-terceiros/edicao', item.id]" style="cursor: pointer;" >{{ item.nomeTipoPagamentoEcgTerceiro }}</td>
        <td  class="text-left" id=col-acoes>
          <a  href="javascript:void(0)" (click)="modalConfirmarExclusao(item.id, item.usadaEmOperacao)">
            <i [ngClass]="item.usadaEmOperacao ? 'text-secondary' : 'text-danger'"  class="fa fa-trash cursor-pointer margin-left-5" placement="left-top" [ngbTooltip]="item.usadaEmOperacao ? 'Exclusão não permitido, pois a modalidade já está em uso' : 'Exclui a modalidade selecionada'"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</section>

 <ng-template #msgTemplateExcluir>
            <span
              >Confirma a exclusão ?
            </span>

          </ng-template>
          <ng-template #botoesPersonalizadosExcluir>
             <button class="btn btn-md btn-light" (click)="dismissModal()">
              Cancelar
            </button>
            <button class="btn btn-md btn-danger" (click)="excluir()">
              Ok
            </button>
   </ng-template>
